import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "olap-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex p-flex-column kn-flex p-m-3"
}
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = {
  key: 0,
  class: "kn-flex-0"
}
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-flex-column p-my-3"
}
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = {
  key: 0,
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-grid p-mt-1" }
const _hoisted_9 = { class: "p-col-4" }
const _hoisted_10 = { class: "p-col-4" }
const _hoisted_11 = { class: "p-col-4" }
const _hoisted_12 = { class: "p-my-3" }
const _hoisted_13 = {
  key: 0,
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-grid p-mt-1" }
const _hoisted_15 = { class: "p-col-4" }
const _hoisted_16 = { class: "p-col-4" }
const _hoisted_17 = { class: "p-col-4" }
const _hoisted_18 = { class: "p-col-4" }
const _hoisted_19 = { class: "p-col-4" }
const _hoisted_20 = { class: "p-col-4" }
const _hoisted_21 = {
  key: 1,
  id: "whatif-container",
  class: "kn-flex"
}
const _hoisted_22 = { class: "kn-material-input-label" }
const _hoisted_23 = { class: "p-grid p-mt-1" }
const _hoisted_24 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_25 = {
  key: 1,
  class: "p-col-4"
}
const _hoisted_26 = {
  key: 2,
  class: "p-col-4"
}
const _hoisted_27 = {
  key: 3,
  class: "p-col-4"
}
const _hoisted_28 = { class: "p-col-4" }
const _hoisted_29 = {
  key: 4,
  class: "p-col-4"
}
const _hoisted_30 = {
  key: 2,
  class: "kn-flex p-mt-3"
}
const _hoisted_31 = { class: "kn-material-input-label" }
const _hoisted_32 = { class: "p-grid p-mt-1" }
const _hoisted_33 = { class: "p-col-4" }
const _hoisted_34 = {
  key: 0,
  class: "p-col-4"
}
const _hoisted_35 = { class: "p-col-4" }
const _hoisted_36 = { class: "p-col-4" }
const _hoisted_37 = {
  key: 3,
  class: "p-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Button = _resolveComponent("Button")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, {
      id: "kn-parameter-sidebar-toolbar",
      class: "kn-toolbar kn-toolbar--secondary"
    }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.settings')), 1)
      ]),
      _: 1
    }),
    (_ctx.olap)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", null, [
            _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('documentExecution.olap.sidebar.drillOnDimension')), 1),
            _createVNode(_component_SelectButton, {
              class: "p-mt-2",
              modelValue: _ctx.drillOn,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.drillOn = $event)),
              options: _ctx.olapSidebarDescriptor.drillOnOptions,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('drillTypeChanged', _ctx.drillOn)))
            }, null, 8, ["modelValue", "options"])
          ]),
          (!_ctx.olapDesignerMode)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (_ctx.isButtonVisible('BUTTON_DRILL_THROUGH'))
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('documentExecution.olap.sidebar.drillOnData')), 1),
                      _createVNode(_component_Button, {
                        class: ["p-button-sm kn-button kn-button--secondary p-as-center p-mt-2", { 'olap-sidebar-button-active': _ctx.enableDrillThrough }],
                        label: _ctx.$t('documentExecution.olap.sidebar.drillThrough'),
                        onClick: _ctx.onDrillThroughClick
                      }, null, 8, ["class", "label", "onClick"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", null, [
                  (_ctx.isButtonVisible('BUTTON_MDX') || _ctx.isButtonVisible('BUTTON_FLUSH_CACHE') || _ctx.olap.modelConfig.crossNavigation)
                    ? (_openBlock(), _createBlock("label", _hoisted_7, _toDisplayString(_ctx.$t('documentExecution.olap.sidebar.olapFunctions')), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      (_ctx.isButtonVisible('BUTTON_MDX'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "far fa-eye",
                            class: "p-button-plain kn-button--secondary",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('openMdxQueryDialog')))
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.mdxQuery'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_10, [
                      (_ctx.isButtonVisible('BUTTON_FLUSH_CACHE'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-sync-alt",
                            class: "p-button-plain kn-button--secondary",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('reloadSchema')))
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.reloadSchema'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_11, [
                      (_ctx.olap.modelConfig.crossNavigation)
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-arrow-right",
                            class: "p-button-plain kn-button--secondary",
                            onClick: _ctx.onEnableCrossNavigationClick
                          }, null, 8, ["onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.enableCrossNavigation'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_12, [
                  (_ctx.tableFunctionsVisible)
                    ? (_openBlock(), _createBlock("label", _hoisted_13, _toDisplayString(_ctx.$t('documentExecution.olap.sidebar.tableFunctions')), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      (_ctx.isButtonVisible('BUTTON_FATHER_MEMBERS'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "far fa-caret-square-up",
                            class: ["p-button-plain kn-button--secondary", { 'olap-sidebar-button-active': _ctx.showParentMembers }],
                            onClick: _ctx.onShowParentMemberClick
                          }, null, 8, ["class", "onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.showParentMembers'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_16, [
                      (_ctx.isButtonVisible('BUTTON_HIDE_SPANS'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-eye-slash",
                            class: ["p-button-plain kn-button--secondary", { 'olap-sidebar-button-active': _ctx.hideSpans }],
                            onClick: _ctx.onHideSpansClick
                          }, null, 8, ["class", "onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.hideSpans'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_17, [
                      (_ctx.isButtonVisible('BUTTON_SORTING_SETTINGS'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-sort-amount-down-alt",
                            class: "p-button-plain kn-button--secondary",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('openSortingDialog')))
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.sortingSettings'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_18, [
                      (_ctx.isButtonVisible('BUTTON_SHOW_PROPERTIES'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-cogs",
                            class: ["p-button-plain kn-button--secondary", { 'olap-sidebar-button-active': _ctx.showProperties }],
                            onClick: _ctx.onShowPropertiesClick
                          }, null, 8, ["class", "onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.showProperties'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_19, [
                      (_ctx.isButtonVisible('BUTTON_HIDE_EMPTY'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-border-none",
                            class: ["p-button-plain kn-button--secondary", { 'olap-sidebar-button-active': _ctx.suppressEmpty }],
                            onClick: _ctx.onSuppressRowsColumnsClick
                          }, null, 8, ["class", "onClick"])), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.suppressEmptyRowsColumns'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_20, [
                      (_ctx.isButtonVisible('BUTTON_SAVE_SUBOBJECT'))
                        ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            icon: "fas fa-save",
                            class: "p-button-plain kn-button--secondary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('openCustomViewDialog')))
                          }, null, 512)), [
                            [
                              _directive_tooltip,
                              _ctx.$t('documentExecution.olap.sidebar.saveCustomizedView'),
                              void 0,
                              { top: true }
                            ]
                          ])
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.olapHasScenario && !_ctx.olapDesignerMode)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('documentExecution.olap.sidebar.whatIfTitle')), 1),
                _createVNode("div", _hoisted_23, [
                  (_ctx.olapLocked)
                    ? (_openBlock(), _createBlock("div", _hoisted_24, [
                        _withDirectives(_createVNode(_component_Button, {
                          icon: _ctx.olapLocked ? 'fas fa-lock-open' : 'fas fa-lock',
                          class: "p-button-plain kn-button--secondary",
                          onClick: _ctx.changeLock
                        }, null, 8, ["icon", "onClick"]), [
                          [
                            _directive_tooltip,
                            _ctx.olapLocked ? _ctx.$t('documentExecution.olap.sidebar.unlockSchema') : _ctx.$t('documentExecution.olap.sidebar.lockSchema'),
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.olapLocked)
                    ? (_openBlock(), _createBlock("div", _hoisted_25, [
                        (_ctx.isButtonVisible('BUTTON_SAVE_SUBOBJECT'))
                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "fa-solid fa-floppy-disk",
                              class: "p-button-plain kn-button--secondary",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('showSaveAsNewVersion')))
                            }, null, 512)), [
                              [
                                _directive_tooltip,
                                _ctx.$t('documentExecution.olap.sidebar.saveAsNewVersion'),
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.olapLocked)
                    ? (_openBlock(), _createBlock("div", _hoisted_26, [
                        (_ctx.isButtonVisible('BUTTON_UNDO'))
                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "fa-solid fa-rotate-left",
                              class: "p-button-plain kn-button--secondary",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('undo')))
                            }, null, 512)), [
                              [
                                _directive_tooltip,
                                _ctx.$t('documentExecution.olap.sidebar.undo'),
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.olapLocked)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        (_ctx.isButtonVisible('BUTTON_VERSION_MANAGER'))
                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "fa-solid fa-trash",
                              class: "p-button-plain kn-button--secondary",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('showDeleteVersions')))
                            }, null, 512)), [
                              [
                                _directive_tooltip,
                                _ctx.$t('documentExecution.olap.sidebar.deleteVersions'),
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_28, [
                    (_ctx.isButtonVisible('BUTTON_EXPORT_OUTPUT'))
                      ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          icon: "fa-solid fa-share-from-square",
                          class: "p-button-plain kn-button--secondary",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('showOutputWizard')))
                        }, null, 512)), [
                          [
                            _directive_tooltip,
                            _ctx.$t('documentExecution.olap.sidebar.outputWizard'),
                            void 0,
                            { top: true }
                          ]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.olapLocked)
                    ? (_openBlock(), _createBlock("div", _hoisted_29, [
                        (_ctx.isButtonVisible('BUTTON_ALGORITHMS'))
                          ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "fa-solid fa-network-wired",
                              class: "p-button-plain kn-button--secondary",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('showAlgorithmDialog')))
                            }, null, 512)), [
                              [
                                _directive_tooltip,
                                _ctx.$t('documentExecution.olap.sidebar.alg'),
                                void 0,
                                { top: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.olapDesignerMode)
            ? (_openBlock(), _createBlock("div", _hoisted_30, [
                _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('documentExecution.olap.sidebar.templateEditing')), 1),
                _createVNode("div", _hoisted_32, [
                  _createVNode("div", _hoisted_33, [
                    _withDirectives(_createVNode(_component_Button, {
                      icon: "far fa-eye",
                      class: "p-button-plain kn-button--secondary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('openMdxQueryDialog')))
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        _ctx.$t('documentExecution.olap.sidebar.mdxQuery'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  (_ctx.whatIfMode)
                    ? (_openBlock(), _createBlock("div", _hoisted_34, [
                        _withDirectives(_createVNode(_component_Button, {
                          icon: "fa-solid fa-note-sticky",
                          class: "p-button-plain kn-button--secondary",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('showScenarioWizard')))
                        }, null, 512), [
                          [
                            _directive_tooltip,
                            _ctx.$t('documentExecution.olap.sidebar.scenario'),
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_35, [
                    _withDirectives(_createVNode(_component_Button, {
                      icon: "fas fa-arrow-right",
                      class: ["p-button-plain kn-button--secondary", { 'olap-sidebar-button-active': _ctx.crossNavigation }],
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('openCrossNavigationDefinitionDialog')))
                    }, null, 8, ["class"]), [
                      [
                        _directive_tooltip,
                        _ctx.$t('documentExecution.olap.sidebar.defineCrossNavigation'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode(_component_Button, {
                      icon: "far fa-check-square",
                      class: "p-button-plain kn-button--secondary",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('openButtonWizardDialog')))
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        _ctx.$t('documentExecution.olap.sidebar.configureButtonsVisiblity'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.olapDesignerMode)
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('documentExecution.olap.sidebar.closeDesigner'),
                  class: "p-button-plain kn-button--secondary",
                  onClick: _ctx.closeOlapDesigner
                }, null, 8, ["label", "onClick"]),
                _createVNode(_component_Button, {
                  label: _ctx.$t('documentExecution.olap.sidebar.saveTemplate'),
                  class: "p-button-plain kn-button--primary p-mt-2",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('saveOlapDesigner')))
                }, null, 8, ["label"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}